/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import moment from 'moment';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';

export default class AbsencesAndTruancyReportRoute extends Route {
  queryParams = {
    dateFrom: {
      refreshModel: true,
      as: 'from',
    },
    dateTo: {
      refreshModel: true,
      as: 'to',
    },
    groupIds: {
      refreshModel: true,
      as: 'groups',
    },
    termId: {
      refreshModel: false,
      as: 'term',
    },
  };

  // Attrs
  @alias('session.school.jurisdiction')
  jurisdiction;

  // Services
  @service
  schoolSchema;

  @service
  session;

  @service
  store;

  model(params) {
    let year = moment().year();
    let dateFrom = isEmpty(params.dateFrom) ? `${year}-01-01` : params.dateFrom;
    let dateTo = isEmpty(params.dateTo) ? `${year}-12-31` : params.dateTo;

    let groupIds = '';
    if (!isEmpty(params.groupIds)) {
      groupIds = JSON.stringify(params.groupIds);
    }

    let data = {
      groups: this.store.query('group', { year }),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
      dayCodes: this.store.query('attendance/day-code', {
        dateFrom,
        dateTo,
        groupIds,
        analysis: true,
      }),
      terms: this.store
        .findAll('term')
        .then((terms) =>
          terms
            .filter((term) => term.year === year)
            .sort((a, b) => a.term - b.term),
        ),
      genderField: this.schoolSchema.getLearnerGenderField(),
    };

    return hash(data);
  }

  resetController(controller) {
    controller.reset();
    // Unload all day codes from the store
    this.store.unloadAll('attendance/day-code');
  }
}
